<template>
  <div class="slide outro" :style="rootStyle">
    <div class="content">
      <h1 class="heading" :style="headingStyle">{{ data.heading || 'Keep learning.' }}</h1>
      <p v-if="data.body" class="body">{{ data.body }}</p>
      <div class="cta" :style="{ color: colors.accent || '#60A5FA' }">
        {{ data.cta || 'Explore the full journey on LearningFirst' }}
      </div>
      <div class="brand">{{ config.brand_name || 'LearningFirst' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Outro',
  props: {
    data: { type: Object, required: true },
    config: { type: Object, default: () => ({}) }
  },
  computed: {
    colors() {
      return this.config.color_scheme || {}
    },
    font() {
      return this.config.font || {}
    },
    rootStyle() {
      return {
        background: this.colors.background || '#0F172A',
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.body || 'Inter, system-ui, sans-serif'
      }
    },
    headingStyle() {
      return {
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.heading || 'Inter, system-ui, sans-serif'
      }
    }
  }
}
</script>

<style scoped>
.slide {
  width: 1920px;
  height: 1080px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 120px;
  box-sizing: border-box;
}
.content {
  max-width: 1400px;
}
.heading {
  font-size: 128px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0;
}
.body {
  font-size: 40px;
  margin-top: 48px;
  opacity: 0.85;
  line-height: 1.4;
}
.cta {
  font-size: 36px;
  font-weight: 600;
  margin-top: 80px;
  letter-spacing: -0.005em;
}
.brand {
  margin-top: 120px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.14em;
  opacity: 0.65;
}
</style>
